import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { env } from '../common/lib/env';
import { createMiddleware } from '../common/middleware';
import { genericStateReducer } from '../common/slices/genericState';

import { emptySplitApi as extendedApi } from './services/api/baseApi';
import { invoiceParamsReducer } from './slices/invoiceParams.js';
import { lateFeeRevertModalReducer } from './slices/revertLateFeeModal';
import { actionDrawerReducer } from './slices/actionDrawer';
import { contactParamsReducer } from './slices/contactParams';
import { contactPagePrefsReducer } from './slices/contactPagePrefs';
import { actionTableModelReducer } from './slices/actionTableModels';
import { modalSlicerReducer } from './slices/modals';
import { previewPolicyReducer } from './slices/previewPolicy';
import { settingsStateReducer } from './slices/settingsState';
import { adhocActionModalReducer } from './slices/adhocActionModal';
import { statementPreviewModalReducer } from './slices/statementPreviewModal';
import { invoiceTableModelsReducer } from './slices/invoiceTableModels';
import { contactTableModelsReducer } from './slices/contactTableModels';
import { escalationTableModelsReducer } from './slices/escalationTableModels';
import { quoteTableModelsReducer } from './slices/quoteTableModels';
import { notesDrawerReducer } from './slices/notesDrawer';
import { assistantDrawerReducer } from './slices/assistantDrawer';

const rootReducer = combineReducers({
  [extendedApi.reducerPath]: extendedApi.reducer,
  invoiceParams: invoiceParamsReducer,
  lateFeeRevertModal: lateFeeRevertModalReducer,
  actionDrawer: actionDrawerReducer,
  actionTableModels: actionTableModelReducer,
  contactParams: contactParamsReducer,
  contactPagePrefs: contactPagePrefsReducer,
  modals: modalSlicerReducer,
  previewPolicy: previewPolicyReducer,
  settingsState: settingsStateReducer,
  adhocActionModal: adhocActionModalReducer,
  genericState: genericStateReducer,
  statementPreviewModal: statementPreviewModalReducer,
  invoiceTabelModels: invoiceTableModelsReducer,
  contactTableModels: contactTableModelsReducer,
  escalationTableModels: escalationTableModelsReducer,
  quoteTableModels: quoteTableModelsReducer,
  notesDrawer: notesDrawerReducer,
  assistantDrawer: assistantDrawerReducer,
});

export type RootState = ReturnType<typeof rootReducer>

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => createMiddleware(getDefaultMiddleware, extendedApi.middleware),
  devTools: !env.isProd,
});

// Configure listeners to allow out of focus detection to pause polling
setupListeners(store.dispatch);
